import * as React from 'react';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface IProps {
    header: string,
    save: (e: any) => void,
    close: () => void,
    applicable: boolean,
    children: any
}

export class EntityPageHeader extends React.Component<IProps, any> {
    public render() {
        return <div style={{ margin: "15px 0" }}>
            <div>
                <Button size="sm" variant="primary" onClick={this.props.save}><FontAwesomeIcon icon="save" />{' '}Сохранить</Button>
                <Button size="sm" variant="light" style={{ marginLeft: "10px" }} onClick={this.props.close}>Закрыть</Button>
                {this.props.children}
            </div>
        </div>
    }
}
